const GA_ID = "G-H7RF7Y4Q92";

let initialized = false;

/**
 * Inject the GA4 gtag.js script and initialise with consent-denied defaults.
 * Called once when analytics consent is granted.
 */
export const initGA = () => {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  // Default: deny everything until explicit consent
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  // Load gtag.js script
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  gtag("config", GA_ID, { send_page_view: false });
};

/**
 * Update Google consent mode based on user preferences.
 */
export const updateConsent = ({ analytics = false, marketing = false }) => {
  if (typeof window === "undefined" || !window.gtag) return;

  window.gtag("consent", "update", {
    analytics_storage: analytics ? "granted" : "denied",
    ad_storage: marketing ? "granted" : "denied",
    ad_user_data: marketing ? "granted" : "denied",
    ad_personalization: marketing ? "granted" : "denied",
  });
};

/**
 * Send a page_view event (call on route changes).
 */
export const trackPageView = (path) => {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
  });
};
